export const COMMAND_DECK_PRESENTATION_MARKER = 'KAIROS_COMMAND_DECK_WORLD_CLASS_HIERARCHY';

const STATUS_PRESENTATION = Object.freeze([
  ['presetLabel', 'mode'],
  ['viewportLabel', 'mode'],
  ['activeSeriesLabel', 'clinical'],
  ['accessionLabel', 'clinical'],
  ['patientIdLabel', 'clinical'],
  ['patientDemographicsLabel', 'clinical'],
  ['studyDescriptionLabel', 'clinical'],
  ['anatomyLabel', 'clinical'],
  ['studyDateLabel', 'context'],
  ['studyTimeLabel', 'context'],
  ['modalityLabel', 'clinical'],
  ['protocolNameLabel', 'context'],
  ['seriesNumberLabel', 'context'],
  ['acquisitionNumberLabel', 'context'],
  ['acquisitionTimeLabel', 'context'],
  ['contrastPhaseLabel', 'context'],
  ['sequenceLabel', 'context'],
  ['reconKernelLabel', 'context'],
  ['patientPositionLabel', 'context'],
  ['pixelSpacingLabel', 'context'],
  ['manufacturerLabel', 'context'],
  ['scannerModelLabel', 'context'],
  ['institutionLabel', 'context'],
  ['stationLabel', 'context'],
  ['toolLabel', 'mode'],
  ['railLabel', 'mode'],
  ['flowLabel', 'mode'],
  ['protocolLabel', 'context'],
  ['compareLabel', 'alert'],
  ['reportContextLabel', 'context'],
  ['sliceProgressLabel', 'clinical'],
  ['zoomFitLabel', 'clinical'],
  ['windowLevelLabel', 'clinical'],
  ['freezeLabel', 'alert'],
  ['planeLabel', 'clinical'],
  ['sliceThicknessLabel', 'clinical'],
  ['seriesCountLabel', 'clinical'],
  ['mprFusionLabel', 'context'],
]);

export const isCommandDeckPlaceholder = label => (
  label == null
  || String(label).trim() === ''
  || /(?:^|\s)--(?:$|\s)/.test(String(label).trim())
);

export const buildVisibleCommandDeckStatus = (status = {}) => STATUS_PRESENTATION
  .map(([key, tier]) => ({ key, tier, label: status[key] }))
  .filter(item => !isCommandDeckPlaceholder(item.label));
